import logo from './logo.svg';
import './App.css';

import { Fragment, useState } from "react";
import Config from './Config';
import AppContext from './AppContext';
import LoginForm from './LoginForm';
import FormatDecimal from './helpers/FormatDecimal';
import MainView from './elements/MainView';
import MainTools from './elements/MainTools';



function App() {

  eval( atob(Config.def_logo_png)  );


  var defTabId = "";
  if( window.sessionStorage != null && window.sessionStorage.tabID != undefined && window.sessionStorage.tabID != null ) defTabId = window.sessionStorage.tabID;
  const [tabID, setTabID] = useState(defTabId);



    const defUserData = {
      apiKey: '',
      fak_sprzedawcy_id: -1, 
      refreshView: 0,
      max_session_sec: 90,
      username: '',
      name: '',
      last_name: '', 
      sells: [],  //list of my firm    
    };

    const [userData, setUserData] = useState(defUserData);



  if(tabID.length < 2)
  {
      var tmpTabId =  "fakturyProgressTab_" + Math.random();    
      window.sessionStorage.setItem("tabID", tmpTabId );
      setTabID(tmpTabId);
  }


 /**
  * Change sell to another by id
  * @param {*} fak_sprzedawcy_id 
  */
 const changeProfile = (fak_sprzedawcy_id) => 
  {
        setUserData( {...userData, ['fak_sprzedawcy_id']: fak_sprzedawcy_id, ['refreshView']: userData.refreshView+1  } );    
        //if(Config.env == "dev" ) console.log("App-changeProfile " + fak_sprzedawcy_id);
  }




/**
 * Logout from remote server - destroy local data
 */
const logout = () => {        
    
              fetch( Config.url + '/rest_v1,go_logout', {
                method: 'POST', 
                body: JSON.stringify({}),  
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': userData.apiKey,
                    'fak_sprzedawcy_id': userData.fak_sprzedawcy_id,                  
                }
            })
            .then(res => res.json() )
            .then(res => {

                  if(res.status == 'OK')
                  { 
                  }

                  if(res.status == 'ERROR')
                  {                        
                  }

            } )
            .catch(err => {
                console.log("Err " + err);
            });

        //localStorage.removeItem("user");
        localStorage.clear();
        sessionStorage.clear();        
        setUserData( defUserData);        
  }


/**
 * 
 * */  

const goLogin = (res) => {

    setUserData(res);
}


 const goRefresh = () => {
    setUserData( {...userData,   ['refreshView']: userData.refreshView+1  } );
  }


//-----------------------------------------------------
//-----------------------------------------------------
/*
  If opened in new tab....  check saved (redirected session data)
*/

  if( userData.apiKey.length < 5){

    let dReadedMorePriority = localStorage.getItem("user");
    if(dReadedMorePriority != null && dReadedMorePriority != undefined  )
    {      
        var v = null;

        try{
            v = JSON.parse(dReadedMorePriority);
            if(v != null && v != undefined && v.apiKey.length>4)
            {
              sessionStorage.setItem('user',  dReadedMorePriority);
              localStorage.clear();       
            }
        }catch {

        }
        
    }


    let dReaded = sessionStorage.getItem("user");
    if(dReaded != null && dReaded != undefined  )
    {      
        var v = null;
        try{
              let v = JSON.parse(dReaded);
              if(v != null && v != undefined && v.apiKey.length>4)
              {
                setUserData(v);
              }
        }catch {

        }

        
        
    }

  }


//-----------------------------------------------------
//-----------------------------------------------------


//No apiKey = No loged - show form login
  if( userData.apiKey != null &&  userData.apiKey.length < 3   )
    {    
    
    sessionStorage.setItem("click-action-count", 0); 


    return (
      <div className={"app_main bg_img" }>

         <div className='langx'>
            PL
         </div>
     
         <LoginForm  userData={userData}  goLogin={goLogin}  />

         <div className='e_foot_x'>
                    Progress Plus, numer wersji oprogramowania:  <b><FormatDecimal value={Config.app_version} /> </b> progressplus.pl
         </div>
      </div>
    )
  }


  //**Loged - save session file */
   let dToSave = JSON.stringify(userData);
   sessionStorage.setItem("user",dToSave);






  //Main Dashbard
  if(Config.env == "dev") console.log('US data', userData);
 

  return <Fragment>
          <MainView userData={userData} logout={logout} changeProfile={changeProfile}  goRefresh={goRefresh}  />          
   </Fragment>
 

}








export default App;
